'use client'
import isServer from '@/lib/utils/is-server'
import {
  QueryClient,
  QueryClientProvider as ClientProvider,
} from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { FC, PropsWithChildren } from 'react'

const isDevToolsEnabled =
  process.env.NEXT_PUBLIC_DEV_TOOLS_IS_ENABLED === 'true'

const makeQueryClient = () => {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // With SSR, we usually want to set some default staleTime
        // above 0 to avoid refetching immediately on the client
        staleTime: 60 * 1000,
      },
    },
  })
}

let browserQueryClient: QueryClient | undefined = undefined

const getQueryClient = () => {
  if (isServer) {
    // Server: always make a new query client
    return makeQueryClient()
  } else {
    // Browser: make a new query client if we don't already have one
    if (!browserQueryClient) {
      browserQueryClient = makeQueryClient()
    }
    return browserQueryClient
  }
}

const QueryClientProvider: FC<PropsWithChildren> = ({ children }) => {
  const queryClient = getQueryClient()
  return (
    <ClientProvider client={queryClient}>
      {children}
      {isDevToolsEnabled && <ReactQueryDevtools initialIsOpen={false} />}
    </ClientProvider>
  )
}

export default QueryClientProvider
